import { Menu, MenuItem } from "@blueprintjs/core";
import React from "react";

import styles from "./playbook-context-menu.module.scss";

interface PlaybookContextMenuProps {
  onDelete: () => void;
  onEdit: () => void;
  onPrintSettings: () => void;
  showPrintSettings?: boolean;
}

export const PlaybookContextMenu = ({
  onDelete,
  onEdit,
  onPrintSettings,
  showPrintSettings,
}: PlaybookContextMenuProps) => {
  return (
    <Menu className={styles.contextMenu}>
      {showPrintSettings && <MenuItem text="Print Settings" onClick={onPrintSettings} icon="print" />}
      <MenuItem text="Edit Playbook" onClick={onEdit} icon="edit" />
      <MenuItem text="Delete Playbook" onClick={onDelete} icon="trash" />
    </Menu>
  );
};
